<script>
import router from '../../router';
export default {
    props: ['title', 'iconSrc', 'headerLink', 'width', 'height'],
    data: function() {
        return {
            widgetWidth: this.width ? this.width : '550px',
            widgetHeight: this.height ? this.height : '100%'
        }
    },
    methods: {
        goToHeaderLink() {
            if(this.headerLink)
                router.push(this.headerLink);
        }
    }
}
</script>

<template>
    <div class="widget card" :style="{ width: widgetWidth, height: widgetHeight }">
        <div class="card-header d-flex align-items-center" v-if="title">
            <div v-bind:class="(headerLink)?'link':''" class="d-flex align-items-center" @click="goToHeaderLink">
                <img v-if="iconSrc" :src="iconSrc" height="35" width="35" />
                <slot name="icon"></slot>
                <h3 class="card-title ml-2 pt-2" v-if="title">{{ title }}</h3>
            </div>
        </div>
        <div class="card-body p-3">
            <slot></slot>
        </div>
    </div>
</template>

<style scoped>
.widget {
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
}

.widget > .card-header > .link:hover {
    cursor: pointer;
}
</style>